/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import React from 'react';
import { GatsbyBrowser } from 'gatsby';

import MainWrapper from '~/templates/MainWrapper';
import LanguageContextProvider from '~/components/LanguageProvider';

import './src/styles/imports.scss';
import { ToastProvider } from '@entur/alert';

// Wraps every page in a component
export const wrapPageElement: GatsbyBrowser['wrapPageElement'] = ({
  element,
  props,
}) => {
  return <MainWrapper {...props}>{element}</MainWrapper>;
};

export const wrapRootElement: GatsbyBrowser['wrapRootElement'] = ({
  element,
}) => {
  return (
    <LanguageContextProvider>
      <ToastProvider>{element}</ToastProvider>
    </LanguageContextProvider>
  );
};

// The Ace Knowledge Widget used in Tog-i-Europa does not scroll to the top
// when moving to a new page and the API does not provide a way to do it.
// This is a workaround to scroll to the top for that page.
export const onRouteUpdate: GatsbyBrowser['onRouteUpdate'] = (route) => {
  if (route?.prevLocation?.pathname.includes('/personvern')) {
    // reload to unload CMP suppress script
    location?.reload?.();
  }
};
